import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import FormStrings from "../utils/form_strings";
import ViewAndFilterHelpers from "../utils/view_and_filter_helpers";

class ReportBook extends React.Component {
  onBookChange = (val, primary, view) => {
    this.props.onChange({ value: val, defaultPrimaryFilter: primary, defaultView: view });
    this.props.onUpdate();
  }

  render() {
    const checkedReportBook = this.props.reportBook;
    const onBookChange = this.onBookChange;
    const cn = classNames;
    const filterObjects = this.props.filterObjects;
    let checkedValue;

    const inputToButton = function (opts) {
      const checked = checkedReportBook === opts.id;
      const defaultPrimary = ViewAndFilterHelpers.filterFromId(filterObjects, opts.default_primary_filter);
      const onChange = () => (onBookChange(opts.id, defaultPrimary.id, defaultPrimary.default_view));
      const classNames = cn({
        btn: true,
        "btn-outline": !checked,
        "btn-primary": true,
        "btn-block": true,
      });

      if (checked) {
        checkedValue = opts.id;
      }
      const btn = <div className="col-xl-6 col-12" onMouseUp={onChange} key={opts.id}><label className={classNames}>{opts.name}</label></div>;
      return btn;
    };
    const inputs = this.props.reportBookOptions.map(inputToButton);
    return (
      <div className="row">
        <input readOnly={true} type="hidden" name={FormStrings.reportBookName} value={checkedValue} />
        {inputs}
      </div>
    );
  }
}

ReportBook.propTypes = {
  reportBook: PropTypes.string.isRequired,
  reportBookOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  filterObjects: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ReportBook;
